import React from 'react';

import PropTypes from 'prop-types';

import Tooltip from '../../Tooltip/Tooltip';
import styles from './ReadOnlyFieldTooltip.module.scss';

const ReadOnlyFieldTooltip = ({ tooltip, children }) => {
  if (!tooltip) return children;

  return (
    <Tooltip content={tooltip} placement="top">
      <span className={styles.trigger}>{children}</span>
    </Tooltip>
  );
};

ReadOnlyFieldTooltip.propTypes = {
  tooltip: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ReadOnlyFieldTooltip.defaultProps = {
  tooltip: null,
};

export default ReadOnlyFieldTooltip;
